import { useDrop } from 'react-dnd';
import { clsx } from 'clsx';
import type { App } from '../../types';

interface DroppableZoneProps {
  id: string;
  onDrop: (app: App, zoneId: string) => void;
  children: React.ReactNode;
  className?: string;
  accept?: string[];
}

export function DroppableZone({ 
  id, 
  onDrop, 
  children, 
  className,
  accept = ['app'] 
}: DroppableZoneProps) {
  const [{ isOver, canDrop }, drop] = useDrop({
    accept,
    drop: (item: { app: App }) => {
      onDrop(item.app, id);
    },
    collect: (monitor) => ({
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop(),
    }),
  });

  return (
    <div
      ref={drop}
      className={clsx(
        'relative transition-colors duration-200',
        {
          'bg-blue-50 dark:bg-blue-900/20 border-2 border-dashed border-blue-300 dark:border-blue-600': 
            isOver && canDrop,
          'bg-gray-50 dark:bg-gray-800/50 border-2 border-dashed border-gray-300 dark:border-gray-600': 
            !isOver && canDrop,
        },
        className
      )}
    >
      {children}
      
      {isOver && canDrop && (
        <div className="absolute inset-0 flex items-center justify-center bg-blue-500/10 dark:bg-blue-400/10 pointer-events-none">
          <div className="bg-blue-500 text-white px-4 py-2 rounded-lg font-medium shadow-lg">
            Drop app here
          </div>
        </div>
      )}
    </div>
  );
}